import React from 'react';
import T from 'prop-types';
import { TextInput } from '@acast/decibel';
import Field from 'shared/components/field';

const ShowTextField = ({
  onChange,
  meta,
  propName,
  label,
  placeholder,
  help,
  value,
  isRequired,
}) => (
  <Field name={propName} label={label} meta={meta} help={help} isRequired={isRequired}>
    <TextInput
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
      value={value}
      invalid={typeof meta.error === 'string'}
    />
  </Field>
);

ShowTextField.propTypes = {
  onChange: T.func,
  meta: T.object,
  propName: T.string,
  label: T.string,
  placeholder: T.string,
  help: T.string,
  value: T.any,
  isRequired: T.bool,
};

export default ShowTextField;
